import * as React from "react";
import { SingleFieldList, ChipField, ReferenceManyField, BooleanField, BooleanInput, TabbedForm, FormTab, FunctionField, Tab, TabbedShowLayout, EditButton, TopToolbar, DateField, Show, SimpleShowLayout, RichTextField, DateInput, Edit, List, Datagrid, TextField, EmailField, SimpleForm, TextInput, ReferenceInput, Create } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices
} from 'react-admin';

export const ServiceTeamsList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="name" label="Display" />
            <TextField source="description" />
            <TextField source="areasServiced" label="Areas Serviced"/>
            <ReferenceManyField label="Technicians" reference="users" target="serviceTeam">
                            <SingleFieldList>
                                <ChipField source="firstName" />
                            </SingleFieldList>
                        </ReferenceManyField>
        </Datagrid>
    </List>
);



export const ServiceTeamsCreate = props => (
    <Create title="Create a new Service Team" {...props}>
        <SimpleForm>

            <TextInput source="name" label="Display" validate={required()}/>
            <TextInput source="description" />
            <TextInput source="areasServiced" label="Areas Serviced"/>

        </SimpleForm>
    </Create>
);


export const ServiceTeamsEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled label="Id" source="id" />
                        <TextInput source="name" label="Display" validate={required()}/>
                        <TextInput source="description" />
                        <TextInput source="areasServiced" label="Areas Serviced"/>

  <ReferenceManyField label="Technicians" reference="users" target="serviceTeam">
    <Datagrid>
    <FunctionField label="Name" render={record => `${record.firstName} ${record.lastName}`} />
    <EmailField source="email" />
    <TextField source="phone" />
    <TextField source="role" />
    </Datagrid>
  </ReferenceManyField>
        </SimpleForm>
    </Edit>
);
